<template>
  <div class="relative">
    <img src="@/assets/images/line/Vector 7.png" alt="lineimg" class="m-auto" />
    <div class="absolute bg-design4 mob-hidden">
      <img
        src="../../../assets/images/bg-des/bgd4.svg"
        alt="bg-polygon"
        class=""
      />
    </div>
    <!-- <div class="absolute bg-design5 mob-hidden">
      <img
        src="../../../assets/images/Ellipse 12.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div> -->
    <!-- <div class="absolute h-full lg:hidden md:hidden block w-full">
      <img
        src="../../../assets/images/line/cg-line-1-1.svg"
        alt="bg"
        class="h-full w-full"
      />
    </div> -->
    <div class="lg:flex md:flex lg:gap-10 md:gap-10 smourservice">
      <div class="lg:w-1/2 md:w-1/2 w-full">
        <div class="lg:pt-0 md:pt-0 pt-5">
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/CG/Caregiver-Page/Our-services.jpg"
            alt=""
            class="m-auto custborderradius"
          />
        </div>
      </div>
      <div
        class="lg:w-1/2 md:w-1/2 w-full z-10 lg:pt-0 md:pt-0"
        id="SolutionDiv"
      >
        <div class="">
          <p
            class="title sm-fsize16 md-fsize25 md:font-normal lg:font-normal font-bold"
          >
            Our Services
          </p>
          <p
            class="subtitle md-fsize18 lg:pt-0 md:pt-5-0 pt-2 lh32px sm-fsize14 mob-hidden"
          >
            Caregiving is invisible, unrecognized, underappreciated and
            deprioritized often by caregivers themselves. Long-term caregiving
            can be overwhelming and can cause compassion fatigue and burnout.
            Our programs and services are designed to empower the caregiver in
            several ways.
          </p>
          <p
            class="subtitle md-fsize18 lg:pt-8 md:pt-8 lh32px sm-fsize13 md-ellipsis-6 sm-lh26 mob-hidden"
          >
            Our workshops equip you with skills and training to better manage
            and cope with this complex and demanding role. The coaching and
            counselling are for individualized attention for your specific,
            unique circumstances. The support groups are safe spaces for you to
            understand and explore your role, lean in for support, and learn
            from each other. We help you create the time and space for
            individual well-being through access to trustworthy home-based care
            services while improving the quality of care that you provide.
          </p>
          <p
            class="subtitle md-fsize18 lg:pt-8 md:pt-8 pt-2 lh32px sm-fsize13 sm-lh26 mob-hidden"
          >
            Caregiver Saathi is here to support you through your caregiving
            journey and beyond.
          </p>

          <p
            class="subtitle md-fsize18 lg:pt-8 md:pt-8 pt-2 lh32px sm-fsize14 sm-lh26 sm-fsize13 min-hidden"
          >
            Long-term caregiving can be overwhelming and can cause compassion
            fatigue. Our learning tools, coaching & counselling programs,
            community support and home-based care services are meant to empower
            the caregiver in several ways. We help you create the time and space
            for individual well-being while improving the quality of care that
            you provide.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    handlecommunity() {
      this.$router.push({ name: "community" });
    },
  },
};
</script>
<style>
@media (max-width: 640px) {
  .smourservice {
    display: flex;
    flex-direction: column-reverse;
  }
  .sm-h-630px {
    height: 650px !important;
  }
}
</style>
